import { Loading, NavigateEditPageButton } from '@/components';
import type { FC } from 'react';
import { useParams } from 'react-router';
import { useUser } from '../_hooks/user';

export const UpdateUserButton: FC = () => {
  const { id } = useParams<{ id: string }>();
  const user = useUser(id);
  if (!id) {
    return null;
  }

  if (user.isPending) {
    return <Loading />;
  }

  if (!user.data || user.data.isIntegrated) {
    return null;
  }

  return <NavigateEditPageButton />;
};
